// 數據看板頁面翻譯
export default {
  // 按鈕
  buttons: {
    viewDetails: "看板詳情",
  },

  // 標籤頁
  tabs: {
    balanceBoard: "餘額看板",
    transactionBoard: "交易看板",
  },

  // 提示信息
  messages: {
    noData: "暫無數據",
  },
};
